import React, { Component } from 'react';

class AdBottom extends Component {
    componentDidMount() {
        try {
            // window.googletag.cmd.push(function () {
            //     window.googletag.display('div-gpt-ad-1410518459199-2');
            // });
            if (window.googletag && window.googletag.apiReady) {
                window.googletag.cmd.push(function () {
                    window.googletag.display('div-gpt-ad-1410518459199-2');
                });
                window.googletag.pubads().refresh([window.gptAdSlots[2]]);
            }
        } catch (e) {
        }
    }

    render() {
        return <div className="si-bottom-ad">
            <div id='div-gpt-ad-1410518459199-2' />
        </div>
    }
}

export default AdBottom;


// WEBPACK FOOTER //
// ./src/components/AdBottom.js